var app = require('app').app;

module.exports = function (interactivity, baseURL) {
    var json = interactivity.json;
    var getMetadata = require('interactivity.metadata.js');

    var m_prcInteractivityMap = {
        defs: {},
        docitems: {},
        procedureItems: {},
        options: {},
        metadata: {}
    };

    /*
        procedure: {
            options: {
                'name': 'value',
                ...
            },
            metadata: {
                'decl-id': 'value',
                ...
            },
            defs: {
                'def': {
                    'DocID': '',
                    'name': 'value',
                    '{decl-id}': 'value',
                },
                ...
            },
            docitems: {
                'DocID': {
                    id: DocID,
                    metadata: {
                        'decl-id': 'value',
                        ...
                    },
                    objectNames: ['def', ...],
                    screentip: ''
                }
                ...
            }
            pictures: [
                {
                    drawing: '',
                    description: '',
                    flags: 0
                }
            ],
            procedureItems: {
                'id': {
                    type: 'procedure|step|action|event'
                    comment: '',
                    description: '',
                    parent: 'id',
                    parentStep: 'id',
                    eventType: '',
                    children: ['id', ...],
                    actions: ['id', ...],
                    events: ['id', ...]
                }
            }
            procedureId: 'id'
        }

    */

    json.$('SimulationInteractivity/DocItems/DocItem').forEach(function (DocItem) {
        var def = DocItem.$attr('id'),
            defInfo = {},
            metadata = {};

        DocItem.$('metadata/value').forEach(function (value) {
            var text = value.$text();
            defInfo[value.$attr("name")] = text;
            defInfo['{' + value.$attr("decl-id") + '}'] = text;
            metadata[value.$attr("decl-id")] = text;
        });

        m_prcInteractivityMap.defs[def] = defInfo;

        var docid = defInfo['{DocID}'];
        if (!m_prcInteractivityMap.docitems[docid]) {
            m_prcInteractivityMap.docitems[docid] = {
                id: docid,
                objectNames: [],
                metadata: metadata,
                screentip: DocItem.$text('tooltip')
            };
        }
        m_prcInteractivityMap.docitems[docid].objectNames.push(def);
    });

    m_prcInteractivityMap.pictures = json.$('SimulationInteractivity/Resources/Picture').map(function (Picture) {
        return {
            description: Picture.$attr('descr'),
            drawing: baseURL + Picture.$text(),
            flags: Picture.$attr('flags') || 0
        };
    });

    m_prcInteractivityMap.options = require('interactivity.options.js')(json);
    m_prcInteractivityMap.metadata = getMetadata(json.$('SimulationInteractivity/SimulationInformation/metadata/value'));

    m_prcInteractivityMap.procedureId = json.SimulationInteractivity.Simulation && (json.SimulationInteractivity.Simulation.$attr('id') || generateId(json.SimulationInteractivity.Simulation));

    var m_count = 1;

    function generateId(node) {
        var id = '_generic_id-' + m_count;
        m_count++;
        if (!node['@attributes']) {
            node['@attributes'] = {};
        }
        node['@attributes']['id'] = id;
        return id;
    }

    function findDescription(id, node) {
        node = node || json.SimulationInteractivity.Simulation;
        var i,
            description = "";
        if (node.$attr('id') != id) {
            if (node.Step) {
                var steps = node.$('Step');
                for (i = 0; i < steps.length && !description; i++) {
                    description = findDescription(id, steps[i]);
                }
            } else if (node.Substep) {
                var substeps = node.$('Substep');
                for (i = 0; i < substeps.length && !description; i++) {
                    description = findDescription(id, substeps[i]);
                }
            }
        } else {
            description = node.$text('Description');
        }
        return description;
    }

    function processEvent(node, parentId) {
        var id = node.$attr('id') || generateId(node);
        m_prcInteractivityMap.procedureItems[id] = {
            id: id,
            type: 'event',
            description: node.$text('Description'),
            eventType: node.$text('Type').toUpperCase(),
            parent: parentId
        };
    }

    function processItem(node, parentId) {
        var i,
            id = node.$attr('id') || generateId(node),
            itemInfo = {
                id: id,
                comment: node.$text('Comment'),
                description: findDescription(id),
                children: node.$('Item').map(function (node) {
                    return node.$attr('id') || generateId(node);
                }),
                actions: node.$('Action').map(function (node) {
                    return node.$attr('id') || generateId(node);
                }),
                metadata: getMetadata(node.$('metadata/value')),
                raw: node
            };
        itemInfo.type = ((itemInfo.children.length + itemInfo.actions.length) > 0 || node['@name'] !== 'Action') ? 'step' : 'action';

        if (parentId) {
            itemInfo.parent = parentId;
        }

        if (itemInfo.type == 'action') {
            delete itemInfo.children;
            delete itemInfo.actions;
            var steps = json.$('SimulationInteractivity/Simulation/Step');
            for (i = 0; i < steps.length; i++) {
                var step = steps[i];
                var substep = step.$('Substep').filter(function (substep) {
                    return substep.$attr('id') == id;
                });
                if (substep.length > 0) {
                    itemInfo.parentStep = step.$attr('id');
                    itemInfo.events = substep[0].$('Event').map(function (node) {
                        processEvent(node, id);
                        return node.$attr('id');
                    });
                    break;
                }
            }
        }

        m_prcInteractivityMap.procedureItems[id] = itemInfo;

        node.$('Action').forEach(function (action) {
            processItem(action, id);
        });

        node.$('Item').forEach(function (item) {
            processItem(item, id);
        });
    }

    if (json.SimulationInteractivity.Procedure) {
        if (!json.SimulationInteractivity.Procedure['@attributes']) {
            json.SimulationInteractivity.Procedure['@attributes'] = {};
        }
        json.SimulationInteractivity.Procedure['@attributes']['id'] = m_prcInteractivityMap.procedureId;
        processItem(json.SimulationInteractivity.Procedure);
        m_prcInteractivityMap.procedureItems[m_prcInteractivityMap.procedureId].type = 'procedure';
        m_prcInteractivityMap.procedureItems[m_prcInteractivityMap.procedureId].comment = json.$text('SimulationInteractivity/Simulation/Comment');
    }

    var appExports = {
        procedure: {
            /**
             * The namespace represents an interface to access the information from the companion file for the interactive procedure.
             * 
             * @namespace
             * @memberof module:solo.app.procedure
             */
            interactivity: {
                /**
                 * @name document
                 * @memberof module:solo.app.procedure.interactivity
                 * @property {XMLDocument} document The XML document for the loaded companion file.
                 */
                //document: document,

                /**
                 * JavaScript representation of the companion file *.interactivity.xml*
                 * 
                 * @name json
                 * @memberof module:solo.app.procedure.interactivity
                 * @property {XMLNodeData} json JavaScript representation of the XML file
                 * 
                 * *XML:*
                 * ```
                 * <node att1="att1-value" att2="att2-value">
                 *      <foo>Foo</foo>
                 *      <bar>
                 *          <![CDATA[  Bar]]>
                 *      </bar>
                 *      <items>
                 *          <item>i1</item>
                 *          <item>i2</item>
                 *          <item>i3</item>
                 *          <item>i4</item>
                 *      </items>
                 * </node>
                 * ```
                 * *JSON:*
                 * ```
                 * {
                 *  "node": {
                 *      "@attributes": {
                 *          "att1": "att1-value",
                 *          "att2": "att2-value"
                 *      },
                 *      "foo": { "#text": "Foo" },
                 *      "bar": { "#text": "  Bar" },
                 *      "items": {
                 *          "item": [
                 *              { "#text": "i1" },
                 *              { "#text": "i2" },
                 *              { "#text": "i3" },
                 *              { "#text": "i4" }
                 *          ]
                 *      }
                 *  }
                 * }
                 * ```
                 */
                //json: json,

                /**
                 * Returns the 3D procedure ID
                 * 
                 * @memberof module:solo.app.procedure.interactivity
                 * @returns {string} 3D procedure ID
                 */
                getProcedureId: function () {
                    return m_prcInteractivityMap.procedureId;
                },

                /**
                 * Returns an array of the 2D illustration from the companion file.
                 * 
                 * @memberof module:solo.app.procedure.interactivity
                 * @returns {ProcedureDrawingInfo[]} Array of 2D illustrations in the procedure
                 */
                getDrawings: function () {
                    return m_prcInteractivityMap.pictures;
                },

                /**
                 * Returns an DocID for the name of 3D object.
                 * 
                 * @memberof module:solo.app.procedure.interactivity
                 * @param {string} name The name of 3D object
                 * @returns {DocID} DocID value
                 */
                getDocIdByObjectName: function (name) {
                    var defInfo = m_prcInteractivityMap.defs[name];
                    if (defInfo) {
                        return defInfo['{DocID}'];
                    }
                    return null;
                },

                /**
                 * Returns an array of the name of 3D object by DocID.
                 * 
                 * @memberof module:solo.app.procedure.interactivity
                 * @param {DocID} docId DocID value
                 * @returns {string[]} An array of the names of 3D objects
                 */
                getObjectNamesByDocId: function (docId) {
                    var docItemInfo = m_prcInteractivityMap.docitems[docId];
                    return docItemInfo ? docItemInfo.objectNames : [];
                },

                /**
                 * Returns information about the 3D item by DocID.
                 * 
                 * @memberof module:solo.app.procedure.interactivity
                 * @param {DocID} docId DocID value
                 * @returns {DocItemInfo} The object represents an information about the 3D item
                 * @since 1.5.2
                 */
                getDocItemInfo: function (docId) {
                    return m_prcInteractivityMap.docitems[docId];
                },

                /**
                 * Returns information about the 3D item.
                 * 
                 * @memberof module:solo.app.procedure.interactivity
                 * @param {string} name The name of 3D object
                 * @returns {DocItemMetadata} The object represents the metadata value of the 3D object by name and id
                 * @since 1.4.0
                 */
                getDocItemMetadata: function (name) {
                    return m_prcInteractivityMap.defs[name];
                },

                /**
                 * Returns an array of all DocID.
                 * 
                 * @memberof module:solo.app.procedure.interactivity
                 * @returns {DocID[]} An array of DocID
                 */
                getDocItems: function () {
                    var res = [];
                    for (var docId in m_prcInteractivityMap.docitems) res.push(docId);
                    return res;
                },

                /**
                 * Returns information about the procedure item.
                 * 
                 * @memberof module:solo.app.procedure.interactivity
                 * @param {string} id Procedure item ID
                 * @returns {ProcedureElementInfo} The object represents an information about the procedure item
                 */
                getProcedureItemInfo: function (id) {
                    return m_prcInteractivityMap.procedureItems[id];
                },

                /**
                 * Returns the publication options from the companion file in form of key-value array.
                 * 
                 * @memberof module:solo.app.procedure.interactivity
                 * @returns {KeyValuePairs} Key-value array
                 */
                getOptions: function () {
                    return m_prcInteractivityMap.options;
                },

                /**
                 * Returns the project metadata from the companion file in form of key-value array.
                 * 
                 * @memberof module:solo.app.procedure.interactivity
                 * @returns {KeyValuePairs} Key-value array
                 */
                getProjectMetadata: function () {
                    return m_prcInteractivityMap.metadata;
                }
            }
        }
    };

    return appExports.procedure;
};

/**
 * The identifier of the 3D object used to link to the document.
 * @typedef {string} DocID
 */

/**
 * The object represents the metadata value of the 3D object by name and id, for example:
 * ```
 *   {
 *      {DocID}: "SH40400", // by metadata id in form: {decl-id}
 *      {_F0CF006A8AC54725A80D5DC19077CD1D}: "SH40400",
 *      {_F519A19D050D45A68584453C44EA85DC}: "1",
 *      DocID: "SH40400",   // by metadata name
 *      "Part Number": "SH40400",
 *      Qty: "1"
 *   }
 * ```
 * @typedef {KeyValuePairs} DocItemMetadata
 * @see {@link module:solo.app.procedure.interactivity.getDocItemMetadata app.procedure.interactivity.getDocItemMetadata()}
 */

/**
 * Information about the element of the procedure, for example:
 * ```
 *   {
 *       type: "procedure",
 *       id: "R84E4929F-26B0-4848-9375-4A1D42DF4F6F",
 *       description: "Pump Disassembly Procedure",
 *       raw: [ ... ],
 *       ...
 *   }
 * ```
 * @typedef {ProcedureRootInfo|ProcedureStepInfo|ProcedureActionInfo|ProcedureAlertInfo} ProcedureElementInfo
 * @prop {string} type The type of the procedure element:
 * - `"procedure"`
 * - `"step"`
 * - `"action"`
 * - `"event"`
 * @prop {string} id The identifier of the procedure element.
 * @prop {string} description Description of the procedure element.
 * @prop {XMLNodeData} raw An XMLNodeData instance that represents an element in the companion file.
 * @see {@link module:solo.app.procedure.interactivity.getProcedureItemInfo app.procedure.interactivity.getProcedureItemInfo()}
 */

/**
 * Information about the procedure, for example:
 * ```
 *   {
 *       type: "procedure",
 *       id: "R84E4929F-26B0-4848-9375-4A1D42DF4F6F",
 *       description: "Pump Disassembly Procedure",
 *       comment: "<p><b><span style=\"font-size: 117%;\">Pump Disassembly Procedure</span></b></p>",
 *       children: [
 *          "R94679328-76C1-46FC-B49E-C23070C14A16",
 *          "R14F8C444-4ADF-4930-B685-4B1E9E613550",
 *          "R6F5017B0-FD12-4636-A638-D77CF6193B65",
 *          "D767D5C6-0D78-4F52-AB27-404E22EB43E0",
 *          ...
 *       ],
 *       actions: [],
 *       metadata: {}
 *   }
 * ```
 * @typedef {ProcedureElementInfo} ProcedureRootInfo
 * @prop {string} type=procedure See {@link ProcedureElementInfo}.
 * @prop {string} id See {@link ProcedureElementInfo}.
 * @prop {string} description See {@link ProcedureElementInfo}.
 * @prop {string} comment The comment to the element of the procedure in the form of an HTML string.
 * @prop {string[]} children Array of identifiers for children elements.
 * @prop {string[]} actions Array of identifiers for actions of the element.
 * @prop {KeyValuePairs} metadata Metadata of the item.
 * @see ProcedureElementInfo
 */

/**
 * Information about the step of the procedure, for example:
 * ```
 *  {
 *      type: "step",
 *      id: "R94679328-76C1-46FC-B49E-C23070C14A16",
 *      description	"1",
 *      comment	"<p>Remove the bolts securing the faceplate to the the casing. Remove the faceplate.</p>",
 *      parent: "R84E4929F-26B0-4848-9375-4A1D42DF4F6F",
 *      children: [],
 *      actions	[
 *          "D6C54479-3203-4473-85E2-637875CA4F18"
 *      ],
 *      metadata: {}
 *   }
 * ```
 * @typedef {ProcedureElementInfo} ProcedureStepInfo
 * @prop {string} type=step See {@link ProcedureElementInfo}.
 * @prop {string} id See {@link ProcedureElementInfo}.
 * @prop {string} description See {@link ProcedureElementInfo}.
 * @prop {string} comment The comment to the element of the procedure in the form of an HTML string.
 * @prop {string} parent The identifier of the parent element in the procedure.
 * @prop {string[]} children Array of identifiers for children elements.
 * @prop {string[]} actions Array of identifiers for actions of the element. See {@link ProcedureActionInfo}.
 * @prop {KeyValuePairs} metadata Metadata of the item.
 * @see ProcedureElementInfo
 */

/**
 * Information about the action in the procedure, for example:
 * ```
 *  {
 *      type: "action",
 *      id: "5124CF6D-621B-46EC-9EF9-B9EDB0FDD496",
 *      description	"",
 *      comment: "<p>Visually inspect all parts. Replace all worn or damaged parts before reassembling pump. It is recommended that new gaskets be installed each time the pump is disassembled and reassembled<span style=\"font-size: 117%;\">.</span></p>",
 *      parent: "R1712E390-60A4-45CC-ACEC-63ED166989EE",
 *      parentStep: "R1712E390-60A4-45CC-ACEC-63ED166989EE",
 *      events: [
 *          "NOTE-694FE061-2655-4CF1-A567-D78212E2FF87"
 *      ],
 *      metadata: {}
 *   }
 * ```
 * @typedef {ProcedureElementInfo} ProcedureActionInfo
 * @prop {string} type=action See {@link ProcedureElementInfo}.
 * @prop {string} id See {@link ProcedureElementInfo}.
 * @prop {string} description See {@link ProcedureElementInfo}.
 * @prop {string} comment The comment to the element of the procedure in the form of an HTML string.
 * @prop {string} parent The identifier of the parent element in the procedure.
 * @prop {string} parentStep The identifier of the parent step corresponding to the step of the VRML procedure.
 * @prop {string[]} Array of identifiers for procedure elements of type `"event"`. See {@link ProcedureAlertInfo}.
 * @prop {KeyValuePairs} metadata Metadata of the item.
 * @see ProcedureElementInfo
 */

/**
 * Information about the alert in the procedure, for example:
 * ```
 *  {
 *      type: "event",
 *      id: "NOTE-694FE061-2655-4CF1-A567-D78212E2FF87",
 *      description: "note001",
 *      parent: "5124CF6D-621B-46EC-9EF9-B9EDB0FDD496",
 *      eventType: ""
 *   }
 * ```
 * @typedef {ProcedureElementInfo} ProcedureAlertInfo
 * @prop {string} type=event See {@link ProcedureElementInfo}.
 * @prop {string} id See {@link ProcedureElementInfo}.
 * @prop {string} description See {@link ProcedureElementInfo}.
 * @prop {string} parent The identifier of the parent action in the procedure.
 * @prop {string} eventType The type of alert:
 * - `"WARNING"`
 * - `"CAUTION"`
 * - `"NOTE"`
 * - custom type
 * @see ProcedureElementInfo
 */

/**
 * Information about the 3D item that is referenced by the document, for example:
 * ```
 * { 
 *      id: "id02",
 *      objectNames: [ "PM005301_2" ],
 *      metadata: {
 *          DocID: "id01",
 *          _6A7337C8022746BA8C02F29B0FC2257F: "Back Plate Assy",
 *          _F0CF006A8AC54725A80D5DC19077CD1D: "PM005302",
 *          _F519A19D050D45A68584453C44EA85DC: "1"
 *      },
 *      screentip: "Back Plate Assy\nP/N: PM005302"
 * }
 * ```
 * @typedef {object} DocItemInfo
 * @prop {DocID} id The unique ID of the 3D item used to link to the document.
 * @prop {string[]} objectNames An array of the names of 3D objects.
 * @prop {KeyValuePairs} metadata Metadata of the 3D item.
 * @prop {string} screentip A string contains a brief note or label pertaining to the 3D item.
 * @see {@link module:solo.app.procedure.interactivity.getDrawings app.procedure.interactivity.getDrawings()}
 */

 /**
 * Information about the 2D drawing in the procedure, for example:
 * ```
 * { 
 *     drawing: "http://.../pump-procedure-1.svg", 
 *     description: "Pump Cross-Section",
 *     flags: 0
 * }
 * ```
 * @typedef {object} ProcedureDrawingInfo
 * @prop {string} drawing The filename or URL of the 2D illustration.
 * @prop {string} description Description of 2D illustration.
 * @prop {number} flags Flags for the 2D illustration.
 * @see {@link module:solo.app.procedure.interactivity.getDrawings app.procedure.interactivity.getDrawings()}
 */